import React, { useContext, useEffect, useState } from "react";
import Ctx from "../../contexts/AppContext";
import { api } from "../../api";
import { crd, sp, rad, type, listRow } from "../../constants/styles";

const fmtPaise = (paise) => "₹" + Math.round(Number(paise || 0) / 100).toLocaleString('en-IN');

export default function AdminVacateQueue() {
  const { h, t, go, setSelVacateId, flash } = useContext(Ctx);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.adminVacateListDisputed();
        if (res?.success) setRows(res.disputed || []);
      } catch (e) {
        flash("Failed to load dispute queue", "error");
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openDetail = (v) => {
    if (setSelVacateId) setSelVacateId(v.id);
    go('adminVacateDetail');
  };

  if (loading) {
    return <div style={{ paddingTop: 40, textAlign: 'center', color: h.ts }}>Loading dispute queue…</div>;
  }

  return (
    <div style={{ paddingTop: 16 }}>
      <button onClick={() => go("dash")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>← Back</button>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <h2 style={{ ...type.h1, color: h.tx, margin: 0 }}>🚩 Vacate Disputes</h2>
        <span style={{ fontSize: 11, color: h.ts }}>{rows.length} pending</span>
      </div>

      {rows.length === 0 ? (
        <div style={{ ...crd(h), padding: 24, textAlign: "center", color: h.ts }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>✓</div>
          <div style={{ fontSize: 13 }}>No disputed vacate requests right now.</div>
          <div style={{ fontSize: 11, color: h.tt, marginTop: 4 }}>Tenants can flag a landlord's deduction proposal to land here.</div>
        </div>
      ) : (
        <div style={{ ...crd(h), padding: 0, overflow: "hidden" }}>
          {rows.map((v, i) => {
            const depositPaise = (Number(v.deposit_rs) || 0) * 100;
            const totalDed = parseInt(v.total_deductions) || 0;
            const refundPaise = Math.max(0, depositPaise - totalDed);
            return (
              <div key={v.id} onClick={() => openDetail(v)} style={{
                ...listRow(h, i === rows.length - 1),
                cursor: "pointer",
                padding: 14,
                alignItems: "stretch",
                flexDirection: "column",
              }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                  <div style={{ ...type.sm, color: h.tx, fontWeight: 700 }}>
                    {v.tenant_name || v.tenant_id}
                  </div>
                  <span style={{
                    fontSize: 10, fontWeight: 700, letterSpacing: 0.3,
                    padding: "3px 10px", borderRadius: 999,
                    background: `${h.rd}15`, color: h.rd,
                  }}>DISPUTED</span>
                </div>
                <div style={{ color: h.sc, fontSize: 11 }}>{v.property_addr || v.property_id}</div>
                <div style={{ color: h.tt, fontSize: 10, marginTop: 2 }}>
                  Org: {v.org_name || v.org_id}
                </div>
                {v.dispute_reason && (
                  <div style={{
                    marginTop: 6, padding: 6,
                    background: `${h.rd}05`, borderLeft: `2px solid ${h.rd}40`,
                    fontSize: 11, color: h.sc, fontStyle: 'italic', lineHeight: 1.4,
                    maxHeight: 50, overflow: 'hidden',
                  }}>"{v.dispute_reason.slice(0, 160)}{v.dispute_reason.length > 160 ? '…' : ''}"</div>
                )}
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, fontSize: 10, color: h.ts }}>
                  <span>Deposit: {fmtPaise(depositPaise)}</span>
                  <span>Deductions: <b style={{ color: h.rd }}>{fmtPaise(totalDed)}</b></span>
                  <span>Refund: <b style={{ color: h.gn }}>{fmtPaise(refundPaise)}</b></span>
                </div>
                <div style={{ fontSize: 9, color: h.tt, marginTop: 4 }}>
                  Disputed {v.disputed_at ? new Date(v.disputed_at).toLocaleDateString('en-IN') : '—'}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
